import fetchConfig from './fetch-config';

function getCleanedUrl(): string {
  const url = new URL(window.location.href);
  url.searchParams.delete('b2b');
  return url.pathname + url.search + url.hash;
}

async function applyB2bFromUrlParam(): Promise<void> {
  if (document.querySelector('[data-b2b-disabled]')) return;

  const params = new URLSearchParams(window.location.search);
  if (!params.has('b2b')) return;

  const cleanedUrl = getCleanedUrl();

  if (document.documentElement.dataset.isB2b === 'true') {
    history.replaceState(null, '', cleanedUrl);
    return;
  }

  try {
    const response = await fetch(window.routes.cart_update_url, {
      ...fetchConfig(),
      body: JSON.stringify({ attributes: { b2b: 'true' } }),
    });

    if (response.ok) {
      window.location.replace(cleanedUrl);
      return;
    }
  } catch {
    // fall through to strip the param without switching
  }

  history.replaceState(null, '', cleanedUrl);
}

applyB2bFromUrlParam();
